var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company" },
    [
      !_vm.selectedRole
        ? _c("div", { staticClass: "no company-card" }, [
            _c("span", [_vm._v("Please select a role")])
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.selectedRole
        ? _c(
            "div",
            { staticClass: "company-info-container" },
            [
              _c("object-main-info", {
                key: _vm.updateObjectMainInfoKey,
                attrs: {
                  fields: _vm.fields,
                  identifier: _vm.role ? _vm.role.name : "",
                  "identifier-label": _vm.$tc("Label", 1),
                  "editing-data": _vm.editingData,
                  "show-edit-button":
                    _vm.actionToExecute !== "addClientRoles" &&
                    _vm.userHasPermission("role_update"),
                  "card-label": _vm.cardLabel,
                  height: _vm.height,
                  "submit-button-label": _vm.submitButtonLabel,
                  "required-fields-filled": _vm.requiredFieldsAreFilled
                },
                on: {
                  "toggle-edit": _vm.toggleEdit,
                  "update-object": _vm.updateCompany
                },
                scopedSlots: _vm._u(
                  [
                    !_vm.showPermissions
                      ? {
                          key: "buttons-before-edit-slot",
                          fn: function() {
                            return [
                              _c("custom-button", {
                                attrs: {
                                  disabled: _vm.permissionsButtonIsDisabled,
                                  icon: "mdi-key",
                                  "icon-size": 13,
                                  height: "20px",
                                  width: "20px",
                                  "button-styling": _vm.buttonStyling
                                },
                                on: { buttonClick: _vm.togglePermissions }
                              })
                            ]
                          },
                          proxy: true
                        }
                      : null,
                    _vm.showPermissions
                      ? {
                          key: "before-fields-slot",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                { staticClass: "permissionMatrixDiv" },
                                [
                                  _c("permission-matrix", {
                                    attrs: {
                                      data: _vm.role
                                        ? _vm.role.permissions
                                        : [],
                                      disabled: !_vm.editingData
                                    },
                                    on: {
                                      change: _vm.checkIfRequiredFieldsAreFilled
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      : null,
                    _vm.showPermissions
                      ? {
                          key: "before-title-slot",
                          fn: function() {
                            return [
                              _c("custom-button", {
                                attrs: {
                                  icon: "mdi-chevron-left",
                                  "icon-size": 14,
                                  height: "16px",
                                  width: "16px",
                                  "button-styling": Object.assign(
                                    {},
                                    _vm.buttonStyling,
                                    { "box-shadow": "none" }
                                  ),
                                  "button-color": "transparent",
                                  "icon-color": "var(--app-primary-base)"
                                },
                                on: { buttonClick: _vm.togglePermissions }
                              })
                            ]
                          },
                          proxy: true
                        }
                      : null
                  ],
                  null,
                  true
                )
              }),
              _vm._v(" "),
              !_vm.showPermissions
                ? _c("role-specific-info", {
                    attrs: {
                      specialDisable:
                        _vm.actionToExecute === "addClientRoles" ? false : true,
                      editingData: _vm.editingData,
                      role: _vm.role ? _vm.role : [],
                      "required-fields-filled": _vm.requiredFieldsAreFilled,
                      users: _vm.role ? _vm.role.users : [],
                      roles: _vm.role ? _vm.role.client_roles : [],
                      workspaces: _vm.role ? _vm.role.workspaces : []
                    },
                    on: {
                      "cancel-edit": function($event) {
                        _vm.discardChangesDialogIsOpen = true
                      },
                      "save-material": function($event) {
                        _vm.saveChangesDialogIsOpen = true
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("loading-spinner", {
        staticStyle: { position: "absolute" },
        attrs: {
          active: _vm.loading,
          "is-full-page": false,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.saveChangesDialogIsOpen,
          title: _vm.$t("SaveChanges"),
          content: _vm.$t("SaveChangesContent"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-content-save",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.saveObject,
          secondaryAction: function($event) {
            _vm.saveChangesDialogIsOpen = false
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.discardChangesDialogIsOpen,
          title: _vm.$t("DiscardChanges"),
          content: _vm.$t("ClusterCreationConfirmation"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.cancelEdit,
          secondaryAction: function($event) {
            _vm.discardChangesDialogIsOpen = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b394480", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b394480","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/SystemManagement/Roles/Roles.vue
// module id = null
// module chunks = 